{
  "accounts": {
    "addToOrg": {
      "placeholder": "Selecciona una organización",
      "subtitle": "El usuario conserva su cuenta, sus estudios y sus paneles.",
      "title": "Añadir a {{name}} a una organización"
    },
    "confirm": {
      "reactivateOrgBody": "La organización vuelve a mostrarse en la app y todos sus miembros pueden volver a iniciar sesión. Los créditos, los elementos compartidos y el contenido archivado no se restauran.",
      "reactivateTitle": "Reactivar a {{name}}",
      "reactivateUserBody": "{{name}} puede volver a iniciar sesión. Los créditos, los elementos compartidos y el contenido archivado no se restauran.",
      "removeBody": "{{name}} perderá el acceso a los estudios y paneles compartidos de {{org}}. Su cuenta seguirá activa como cuenta individual.",
      "removeTitle": "Quitar de la organización"
    },
    "credits": {
      "balance": "Nuevo saldo",
      "confirm": "Guardar",
      "subtitle": "Define el saldo de créditos o cambia a ilimitados.",
      "title": "Gestionar los créditos de {{name}}"
    },
    "drawer": {
      "created": "Creación",
      "creditBalance": "Saldo de créditos",
      "details": "Detalles",
      "id": "ID",
      "lastSignIn": "Último inicio de sesión",
      "libraryPanel": "Biblioteca de Foresight",
      "members": "Miembros",
      "never": "Nunca",
      "noMembers": "Aún no hay miembros.",
      "noPanels": "Aún no hay paneles.",
      "offboardedAt": "Baja",
      "ownedBy": "Propiedad de {{name}}",
      "panels": "Paneles",
      "panelsCount": {
        "one": "{{count}} panel",
        "other": "{{count}} paneles"
      }
    },
    "empty": "Aún no hay cuentas en {{region}}.",
    "emptySearch": "Ninguna cuenta coincide con tu búsqueda.",
    "filters": {
      "all": "Todas",
      "individuals": "Individuales",
      "orgs": "Organizaciones",
      "showOffboarded": "Mostrar cuentas dadas de baja"
    },
    "hiddenOtherRegion": {
      "one": "{{count}} cuenta fuera de {{region}} está oculta. Cambia de región para gestionarla.",
      "other": "{{count}} cuentas fuera de {{region}} están ocultas. Cambia de región para gestionarlas."
    },
    "menu": {
      "addMember": "Añadir miembro",
      "addToOrg": "Añadir a una organización",
      "assignPanels": "Asignar paneles",
      "makeAdmin": "Convertir en admin",
      "makeMember": "Convertir en miembro",
      "makeOwner": "Convertir en propietario",
      "manageCredits": "Gestionar créditos",
      "offboardOrg": "Dar de baja la organización",
      "offboardUser": "Dar de baja al usuario",
      "reactivate": "Reactivar",
      "removeFromOrg": "Quitar de la organización",
      "removeOwnerDisabled": "Transfiere la propiedad para quitarlo"
    },
    "orgsCount": {
      "one": "{{count}} organización",
      "other": "{{count}} organizaciones"
    },
    "roles": {
      "admin": "Admin",
      "member": "Miembro",
      "owner": "Propietario"
    },
    "search": "Buscar organizaciones, usuarios, correos…",
    "ssoEnabled": "SSO",
    "status": {
      "active": "Activo",
      "offboarded": "De baja"
    },
    "stripeLinked": "Stripe",
    "subtitle": "{{orgs}} · {{users}} en {{region}}",
    "table": {
      "account": "Cuenta",
      "created": "Creación",
      "credits": "Créditos",
      "lastActive": "Última actividad",
      "members": "Miembros",
      "membersCount": {
        "one": "{{count}} miembro",
        "other": "{{count}} miembros"
      },
      "panels": "Paneles",
      "status": "Estado",
      "type": "Tipo"
    },
    "title": "Cuentas",
    "types": {
      "individual": "Individual",
      "org": "Organización"
    },
    "unlimitedCredits": "Ilimitado",
    "usersCount": {
      "one": "{{count}} usuario",
      "other": "{{count}} usuarios"
    }
  },
  "audienceBuilder": {
    "allGenders": "Todos los géneros",
    "countryCount": {
      "one": "{{count}} país",
      "other": "{{count}} países",
      "zero": "Mundo entero"
    },
    "extraFilters": {
      "one": "+{{count}} filtro",
      "other": "+{{count}} filtros",
      "zero": "Sin filtros"
    }
  },
  "auth": {
    "subtitle": "Investigación de mercado continua para marcas que se mueven rápido.",
    "tagline": "Simula cada audiencia, ",
    "taglineItalic": "obtén insights en minutos"
  },
  "console": {
    "actions": {
      "archive": "Archivar",
      "delete": "Eliminar permanentemente",
      "seeRuns": "Ver ejecuciones",
      "transfer": "Transferir"
    },
    "adminBadge": "Admin",
    "chart": {
      "runsOverTime": "Ejecuciones en el tiempo",
      "runsOverTimeSubtitle": "Estudios + preguntas adhoc lanzadas",
      "statusBreakdown": "Desglose por estado",
      "totalRuns": {
        "one": "{{count}} ejecución en total",
        "other": "{{count}} ejecuciones en total"
      }
    },
    "confirm": {
      "archiveBody": "¿Seguro que quieres archivar «{{name}}»?",
      "archiveTitle": "Archivar elemento",
      "archiving": "Archivando…",
      "deleteBody": "¿Seguro que quieres eliminar permanentemente «{{name}}»? Esta acción no se puede deshacer.",
      "deleteTitle": "Eliminar permanentemente",
      "deleting": "Eliminando…"
    },
    "custom": "Personalizado",
    "from": "Desde",
    "kpi": {
      "activeClients": "Cuentas activas",
      "adhoc": "Adhoc",
      "avgDuration": "Duración media",
      "completion": "Tasa de completado",
      "cost": "Coste",
      "respondents": {
        "one": "Participante",
        "other": "Participantes"
      },
      "studies": "Estudios",
      "successRate": "Tasa de éxito",
      "totalRuns": "Total ejecuciones"
    },
    "panel": {
      "loadMore": "Cargar más",
      "loading": "Cargando…",
      "noAdhoc": "No se encontraron preguntas adhoc",
      "noAdhocSearch": "Ninguna pregunta coincide con tu búsqueda",
      "noStudies": "No se encontraron estudios",
      "noStudiesSearch": "Ningún estudio coincide con tu búsqueda",
      "searchAdhoc": "Buscar preguntas…",
      "searchStudies": "Buscar estudios…",
      "tabAdhoc": "Adhoc",
      "tabStudies": "Estudios"
    },
    "runs": {
      "calls": {
        "one": "{{count}} llamada",
        "other": "{{count}} llamadas"
      },
      "characters": {
        "one": "{{value}} carácter",
        "other": "{{value}} caracteres"
      },
      "llm": "LLM",
      "noCost": "No se registró ningún coste para esta ejecución.",
      "noRuns": "Aún no hay ejecuciones.",
      "title": "Ejecuciones y costes",
      "tokens": {
        "one": "{{value}} token",
        "other": "{{value}} tokens"
      },
      "total": "Total",
      "translation": "Traducción",
      "usageType": {
        "llm": {
          "chat": "Chat de resultados",
          "conversation": "Conversación con el persona",
          "narrative": "Narrativa del persona",
          "other": "Otro",
          "research": "Investigación de personas",
          "simulation": "Simulación de persona",
          "suggest": "Sugerencias de preguntas",
          "summary": "Resumen de IA",
          "visualization": "Generación de gráficos"
        },
        "translation": {
          "content": "Traducción de contenido",
          "miscellaneous": "Etiquetas de interfaz",
          "other": "Otro",
          "prompt": "Traducción de instrucciones",
          "summary": "Traducción del resumen",
          "verbatim": "Traducción de verbatims"
        }
      }
    },
    "status": {
      "completed": "Completado",
      "draft": "Borrador",
      "failed": "Fallido",
      "queued": "En cola",
      "running": "En curso"
    },
    "subtitle": "Vista general — ejecuciones, clientes y métricas de rendimiento",
    "table": {
      "adhocCount": "Adhoc",
      "avgDuration": "Prom.",
      "client": "Cliente",
      "clients": "Clientes",
      "clientsCount": {
        "one": "{{count}} cliente",
        "other": "{{count}} clientes"
      },
      "completion": "Completado",
      "cost": "Coste",
      "failedRuns": "Fallidos",
      "lastRun": "Última ejecución",
      "membersCount": {
        "one": "{{count}} miembro",
        "other": "{{count}} miembros"
      },
      "studyCount": "Estudios",
      "successRate": "Éxito",
      "successRuns": "Éxitos",
      "totalRuns": "Ejec."
    },
    "title": "Consola Interna",
    "transfer": {
      "confirm": "Transferir",
      "external": "Externo",
      "noResults": "No se encontraron usuarios.",
      "searchHint": "Busca un usuario por nombre o correo electrónico.",
      "searchPlaceholder": "Buscar usuarios…",
      "subtitle": "Reasignar la propiedad a otro usuario.",
      "title": "Transferir estudio",
      "transferring": "Transfiriendo…"
    }
  },
  "credentials": {
    "copied": "Copiado",
    "copy": "Copiar",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "subtitle": "Compártelos con el cliente. Las contraseñas no se volverán a mostrar.",
    "title": "Datos de acceso"
  },
  "errors": {
    "unknown": "Algo salió mal. Inténtalo de nuevo."
  },
  "forms": {
    "optional": "Opcional",
    "org": {
      "addDomain": "Añadir",
      "credits": "Créditos iniciales",
      "creditsHint": "Se añaden al saldo de créditos al crear la cuenta.",
      "domains": "Dominios de correo",
      "domainsHint": "Solo los correos de estos dominios pueden unirse a esta organización.",
      "domainsRequired": "Añade al menos un dominio.",
      "enrollment": {
        "automaticInvitation": "Invitación automática",
        "automaticSuggestion": "Sugerir unirse",
        "enterpriseSso": "SSO",
        "manualInvitation": "Solo invitación manual"
      },
      "logo": "Logo",
      "logoHint": "PNG o JPG. Las imágenes cuadradas quedan mejor.",
      "logoRemove": "Quitar",
      "logoReplace": "Reemplazar",
      "logoUpload": "Subir imagen",
      "name": "Nombre de la organización",
      "region": "Región",
      "regionHint": "Todos los miembros de esta organización se asignan a esta región.",
      "seatLimit": "Límite de miembros",
      "seatLimitHint": "Déjalo vacío para no limitar los miembros.",
      "slug": "Slug",
      "slugHint": "Se usa en las URL. Se genera a partir del nombre.",
      "stripeCustomerId": "ID de cliente de Stripe",
      "stripeCustomerIdHint": "Vincula la facturación a un cliente de Stripe existente.",
      "unlimitedCredits": "Créditos ilimitados"
    },
    "owner": {
      "existing": "Usuario existente",
      "new": "Nuevo usuario",
      "subtitle": "Pasa a ser admin de la organización y propietario predeterminado de los paneles asignados.",
      "title": "Propietario"
    },
    "panels": {
      "assign": {
        "one": "Asignar {{count}} panel",
        "other": "Asignar {{count}} paneles"
      },
      "assignSubtitle": "Da a este cliente paneles de la biblioteca de Foresight.",
      "assignTitle": "Asignar paneles a {{name}}",
      "copy": "Copiar en la cuenta",
      "copyDescription": "El cliente recibe su propia copia. Las actualizaciones de la biblioteca no se aplican.",
      "default": "Panel predeterminado",
      "defaultHint": "Preseleccionado cuando el cliente crea un estudio.",
      "defaultNone": "Ninguno",
      "library": "Biblioteca de paneles",
      "libraryEmpty": "No hay paneles en la biblioteca de esta región.",
      "librarySubtitle": "Paneles de la biblioteca de esta región",
      "mode": "Cómo asignar",
      "noMatches": "Ningún panel coincide con tu búsqueda.",
      "orgAccess": "Acceso de la organización",
      "orgAccessHint": "Lo que los demás miembros de la organización pueden hacer con estos paneles.",
      "owner": "Propietario",
      "ownerHint": "Las copias pertenecen a este miembro.",
      "ownerPlaceholder": "Selecciona un miembro",
      "restricted": "Restringido",
      "searchPlaceholder": "Buscar paneles…",
      "selectedCount": {
        "one": "{{count}} seleccionado",
        "other": "{{count}} seleccionados"
      },
      "share": "Compartir el panel de la biblioteca",
      "shareDescription": "Enlace de solo lectura al panel de la biblioteca. Las actualizaciones se reflejan automáticamente.",
      "view": "Puede ver"
    },
    "placeholders": {
      "domain": "marca.es",
      "email": "maria.garcia@marca.es",
      "firstName": "María",
      "lastName": "García",
      "memberEmail": "colega@marca.es",
      "orgName": "Bebidas Acme",
      "slug": "bebidas-acme",
      "stripeCustomerId": "cus_…"
    },
    "regionLockHint": "La misma que la región que estás viendo. Cámbiala desde la barra superior.",
    "required": "Obligatorio",
    "saving": "Guardando…",
    "user": {
      "addMember": "Añadir miembro",
      "addMemberSubtitle": "Los nuevos miembros reciben la región de la organización.",
      "addMemberTitle": "Añadir miembro a {{name}}",
      "create": "Crear usuario",
      "createSubtitle": "Crea el usuario de Clerk en tu región actual.",
      "createTitle": "Nuevo usuario",
      "creditsHint": "Se añaden al saldo de créditos del usuario. Los miembros de una organización usan el saldo de créditos de la organización.",
      "email": "Correo electrónico",
      "emailDomain": "Usa un correo de {{domains}}.",
      "emailInvalid": "Introduce un correo válido.",
      "firstName": "Nombre",
      "lastName": "Apellido",
      "noOrg": "Sin organización (individual)",
      "org": "Organización",
      "orgHint": "Déjalo vacío para una cuenta individual.",
      "regionFromOrg": "Heredada de {{name}}.",
      "role": "Rol",
      "seatLimitReached": {
        "one": "Esto supera el límite de {{count}} miembro.",
        "other": "Esto supera el límite de {{count}} miembros."
      }
    },
    "userPicker": {
      "change": "Cambiar",
      "inOrg": "Ya está en {{name}}",
      "noResults": "No se encontraron usuarios.",
      "offboarded": "De baja",
      "otherDomain": "El correo no es de {{domains}}",
      "otherRegion": "Otra región",
      "placeholder": "Buscar por nombre o correo…"
    }
  },
  "misc": {
    "archived": "Archivado",
    "cancel": "Cancelar",
    "daysShort": "{{count}}d",
    "errorOccurred": "Ha ocurrido un error.",
    "hoursShort": "{{count}}h",
    "minutesShort": "{{count}}m",
    "retrying": "Reintentando...",
    "secondsShort": "{{count}}s",
    "tryAgain": "Intentar de nuevo",
    "unknown": "Desconocido"
  },
  "nav": {
    "accounts": "Cuentas",
    "onboardClient": "Dar de alta un cliente",
    "usage": "Uso"
  },
  "notFound": {
    "goToHomeScreen": "Ir a la pantalla de inicio",
    "notFound": "No se puede encontrar lo que buscas"
  },
  "offboard": {
    "confirmOrg": "Dar de baja la organización",
    "confirmUser": "Dar de baja al usuario",
    "contentLabel": "Estudios, preguntas adhoc y paneles",
    "deactivate": "Desactivar a los miembros",
    "deactivateDescription": "Bloquea el inicio de sesión de todos los miembros y revoca sus sesiones.",
    "delete": "Eliminar permanentemente",
    "deleteDescription": "Elimina todo el contenido. Esta acción no se puede deshacer.",
    "detach": "Solo quitar de la organización",
    "detachDescription": "Los miembros conservan sus cuentas individuales, pero pierden el acceso compartido.",
    "effectsTitle": "Qué ocurrirá",
    "keep": "Conservar (archivado)",
    "keepDescription": "Se archiva y un admin de Foresight puede recuperarlo.",
    "membersLabel": "Miembros",
    "newOwner": "Nuevo propietario de la organización",
    "newOwnerHint": "Obligatorio: este usuario es el propietario de la organización.",
    "newOwnerPlaceholder": "Selecciona un miembro",
    "offboarding": "Dando de baja…",
    "orgEffects": "Se revocan los elementos compartidos de la organización, se pierden los créditos restantes y la organización se oculta en la app.",
    "orgSubtitle": "Cierra la organización del cliente y sus accesos.",
    "ownerBlocked": "Este usuario es el único miembro de {{name}}. Da de baja la organización en su lugar.",
    "stats": {
      "credits": "Créditos",
      "members": "Miembros",
      "panels": "Paneles"
    },
    "staysInOrg": "Este usuario permanece en {{name}} como miembro desactivado.",
    "title": "Dar de baja a {{name}}",
    "typeToConfirm": "Escribe {{value}} para confirmar",
    "userEffects": "Se desactiva el inicio de sesión, se revocan las sesiones activas, se eliminan los elementos compartidos directamente y se pierden los créditos restantes.",
    "userSubtitle": "Desactiva la cuenta."
  },
  "onboard": {
    "addMember": "Añadir miembro",
    "back": "Atrás",
    "done": "Listo",
    "doneSubtitle": "Las cuentas y los paneles están listos.",
    "doneTitle": "Cliente dado de alta",
    "individualDescription": "Un solo usuario con su propio saldo de créditos.",
    "individualType": "Individual",
    "launch": "Dar de alta al cliente",
    "memberErrors": "Rellena el nombre, el apellido y un correo único de {{domains}} para cada miembro.",
    "members": "Miembros",
    "membersSubtitle": "Se añaden a la organización.",
    "next": "Siguiente",
    "noMembers": "No hay más miembros. Puedes añadirlos más tarde.",
    "orgDescription": "Un equipo que comparte un saldo de créditos, paneles y estudios.",
    "orgType": "Organización",
    "owner": "Propietario",
    "pasteAdd": "Añadir correos",
    "pasteList": "Pegar lista",
    "pastePlaceholder": "Pega correos separados por comas, espacios o saltos de línea",
    "regionNote": "Todos los miembros de esta organización se crean en {{region}}, la región de la organización.",
    "review": {
      "edit": "Editar",
      "individual": "Individual",
      "name": "Nombre",
      "noPanels": "No hay paneles asignados.",
      "org": "Organización",
      "unlimited": "Ilimitado"
    },
    "running": "Dando de alta…",
    "stepOf": "Paso {{current}} de {{total}}",
    "steps": {
      "client": "Cliente",
      "panels": "Paneles",
      "people": "Personas",
      "review": "Revisión"
    },
    "subtitle": "Todo se crea en {{region}}.",
    "tasks": {
      "addMembers": {
        "one": "Añadiendo {{count}} miembro",
        "other": "Añadiendo {{count}} miembros"
      },
      "createOrg": "Creando {{name}} en {{region}}",
      "createOwner": "Creando la cuenta de propietario de {{name}}",
      "createUser": "Creando a {{name}} en {{region}}",
      "panels": {
        "one": "Asignando {{count}} panel",
        "other": "Asignando {{count}} paneles"
      }
    },
    "title": "Dar de alta un cliente"
  },
  "panels": {
    "default": "Predeterminado"
  },
  "region": {
    "eu": "Europa",
    "switch": "Cambiar de región",
    "switchBody": "Verás y gestionarás las cuentas de {{name}}.",
    "switchScope": "Esto cambia tu región en todo Foresight, no solo en la consola: la app de Foresight también mostrará los datos de {{name}} y los tokens que generes en la consola serán para {{name}}.",
    "switchTitle": "¿Cambiar a {{name}}?",
    "switching": "Cambiando…",
    "us": "Estados Unidos"
  }
}
